var login = {
  translation: {
    common: {
      accept: 'Accept',
      alreadyUser: 'Already a user?',
      and: 'and',
      backToLogin: 'Back to login page',
      continueWith: 'Continue with {{provider}}',
      createAccount: 'Create an account',
      createYourAccount: 'Create your account',
      emailOrUsername: 'Email or username',
      login: 'Login',
      logIn: 'Log in',
      logInToBoards: 'Log in',
      newToBoards: 'New to Viki Teams?',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      privacyPolicy: 'Privacy Policy',
      register: 'Register',
      registerWithGoogle: 'Register with Google',
      termsOfService: 'Terms of Service',
      togglePasswordVisibility: 'Toggle password visibility',
    },
  },
};

export { login as default };
